module.exports = __webpack_public_path__ + "static/img/2.5a38c32.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/eng/2.png
// module id = yTzv
// module chunks = 0